import cls from 'clsx';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { getRole } from '@link/admin/services';
import { NAV_ITEMS } from './constants';

import styles from './sidebar.module.css';

const Sidebar = () => {
  const { t } = useTranslation();
  const role = getRole();
  const navItems = role ? NAV_ITEMS[role] : [];

  return (
    <aside className={styles.sidebar}>
      <div className={styles.inner}>
        <nav className={styles.navList}>
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cls(styles.link, { [styles.activated]: isActive })
              }
            >
              {t(item.labelKey)}
            </NavLink>
          ))}
        </nav>

        <p className={styles.copyright}>{t('common.copyright')}</p>
      </div>
    </aside>
  );
};

export default Sidebar;
